import { httpClient } from '@/shared/api/httpClient';

export interface NextActionOptionDto {
  id: string;
  exhibitorId: string;
  label: string;
  displayOrder: number;
}

export const nextActionsApi = {
  listByExhibitor: (exhibitorId: string) =>
    httpClient.get<NextActionOptionDto[]>(`/api/next-actions?exhibitorId=${exhibitorId}`),
  create: (exhibitorId: string, label: string) =>
    httpClient.post<NextActionOptionDto>('/api/next-actions', { exhibitorId, label }),
  update: (id: string, label: string) =>
    httpClient.put<NextActionOptionDto>(`/api/next-actions/${id}`, { label }),
  delete: (id: string) => httpClient.delete<void>(`/api/next-actions/${id}`)
};